import '@/shared/i18n/client'
import '@/shared/assets/styles/globals.css'

import { createRoot } from 'react-dom/client'

import { env } from '@/shared/config/env'
import Sentry from '@/shared/lib/sentry'

import App from './app'

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement, {
	// Callback called when an error is thrown and not caught by an ErrorBoundary.
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error('Uncaught error', error, errorInfo.componentStack)
	}),
	// Callback called when React catches an error in an ErrorBoundary.
	onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn('Uncaught error', error, errorInfo.componentStack)
	}),
	// Callback called when React automatically recovers from errors.
	onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error('Uncaught error', error, errorInfo.componentStack)
	}),
})

async function enableMocking() {
	if (env.VITE_MOCK_ENABLED !== 'true') {
		return
	}

	const { worker, seedDb } = await import('../mocks')

	// `worker.start()` returns a Promise that resolves
	// once the Service Worker is up and ready to intercept requests.
	await worker.start({
		/* serviceWorker: {
			options: {
				// Narrow down the scope of the pages that the worker can control.
				scope: '/api/v1/scenarios/query',
			},
		}, */
	})
	await seedDb()
}

enableMocking().then(() => {
	root.render(<App />)
})
// Hack to avoid flickering when switching themes
function initTheme() {
	const el = document.documentElement
	const theme = localStorage.getItem('theme')

	const getSystemTheme = () =>
		window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'

	const setTheme = (theme: string) => {
		el.classList.remove(theme)
		el.classList.add(theme)
		el.style.colorScheme = theme
	}

	if (!theme || theme === 'system') {
		setTheme(getSystemTheme())
	} else {
		setTheme(theme)
	}
}
initTheme()
